<script setup lang="ts">
import { StudyCreate } from '@/components/study_create';
</script>

<template>
  <div class="study-create-container">
    <StudyCreate />
  </div>
</template>

<style scoped lang="scss">
.study-create-container {
  height: 100%;
  overflow-y: scroll;
}
</style>
